import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TEmailListItem } from 'redux/reducers/emails/types';
import { EEmEnums } from 'redux/reducers/emManagement/constants';
import { DATES } from '../../../../services/constants/dates-constants';
import { DATES_ID } from '../../../../services/constants/dates-constants';

export const tableStructure: TTableStructure<keyof TEmailListItem>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TEmailListItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Sent at',
		selector: 'sentAt' as keyof TEmailListItem,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
	},
	{
		name: 'Delivered at',
		selector: 'deliveredAt' as keyof TEmailListItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created at',
		selector: 'createdAt' as keyof TEmailListItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Type',
		selector: 'typeHandle' as keyof TEmailListItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.ARRAY_ID,
		align: ETableStructureAlign.LEFT,
		enumName: EEmEnums.EMAIL_TYPE,
	},
	{
		name: 'Subject',
		selector: 'subject' as keyof TEmailListItem,
		show: true,
		sortable: true,
		filterable: false,
		// searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Recipients',
		selector: 'recipients' as keyof TEmailListItem,
		show: true,
		sortable: false,
		filterable: false,
		// searchable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS_ARRAY,
		align: ETableStructureAlign.LEFT,
		filter: [
			['shirin@easproject.com', 'shirin@easproject.com'],
			['bounced', 'Bounced'],
			['delivered', 'Delivered'],
		],
	},
	{
		name: 'Status',
		selector: 'status' as keyof TEmailListItem,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['open', 'Open'],
			['bounced', 'Bounced'],
			['delivered', 'Delivered'],
			['sent', 'Sent'],
		],
		colors: [
			['open', 'primary.light'],
			['bounced', 'error.light'],
			['delivered', 'success.light'],
			['sent', 'info.light'],
		],
	},
	// {
	// 	name: '',
	// 	selector: 'id' as keyof TEmailListItem,
	// 	show: true,
	// 	sortable: false,
	// 	filterable: false,
	// 	colSpan: 1,
	// 	type: ETableStructureType.LINK,
	// 	align: ETableStructureAlign.RIGHT,
	// },
];
